module.exports = __webpack_public_path__ + "img/the-futuristic-and-utopian-world-dionisio-gonzlez-8-868.ee2a0752.jpg";